/** Hint one-shot: “Tieni premuto per spostare” sul grip mobile. */

export const SCHEDULER_MOBILE_DRAG_HINT_KEY = 'scheduler_mobile_drag_hint_seen';

export const SCHEDULER_PERSISTED_KEYS = [
  SCHEDULER_MOBILE_DRAG_HINT_KEY,
  'calendarParams',
];

/** Una sola card mostra il tip per sessione (evita N tooltip). */
let sessionSlotTaken = false;

const readFlag = (key) => {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const writeFlag = (key) => {
  try {
    localStorage.setItem(key, '1');
  } catch {
    // private mode / quota
  }
};

export const isMobileDragHintSeen = () => readFlag(SCHEDULER_MOBILE_DRAG_HINT_KEY);

/** Riserva lo slot tip: true solo per la prima card eleggibile della sessione. */
export const claimMobileDragHintSlot = () => {
  if (isMobileDragHintSeen()) return false;
  if (sessionSlotTaken) return false;
  sessionSlotTaken = true;
  return true;
};

/** Se la card con tip si smonta senza dismiss, un’altra può riprendersi lo slot. */
export const releaseMobileDragHintSlot = () => {
  if (isMobileDragHintSeen()) return;
  sessionSlotTaken = false;
};

export const dismissMobileDragHint = () => {
  writeFlag(SCHEDULER_MOBILE_DRAG_HINT_KEY);
  sessionSlotTaken = true;
};
